import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router'
import { RouterProvider } from 'react-router/dom'
import { wrapCreateBrowserRouterV7 } from '@sentry/react'
import { ServiceError } from 'entities/Sentry/ui/ServiceError'
import { type EntitiesStore } from 'entities/EntitiesExport'
import { ProviderEntities } from 'entities/EntitiesExport/context/entitiesContext'
import { PresentationModeLayout } from 'widgets/PresentationMode'
import type { CallPopUpGlobalStore } from 'widgets/CallPopUp'
import { ProviderCallPopUpGlobal } from 'widgets/CallPopUp/context/callPopUpGlobalContext'
import { SettingsMenu } from 'pages/settings/layout/SettingsMenu'
import { RootLayout } from 'app/shared/layouts'
import AuthLayout from './layouts/AuthLayout'

const routes = createRoutesFromElements(
  <Route element={<PresentationModeLayout />}>
    <Route element={<RootLayout />} errorElement={<ServiceError name='settings-menu' />}>
      <Route element={<AuthLayout />}>
        <Route path='/*' element={<SettingsMenu />} />
      </Route>
    </Route>
  </Route>
)

const router = wrapCreateBrowserRouterV7(createBrowserRouter)(routes)

type ISettingsMenuServiceProps = {
  entities: EntitiesStore
  callPopUpGlobalStore: CallPopUpGlobalStore
}

export const SettingsMenuService = ({
  entities,
  callPopUpGlobalStore,
}: ISettingsMenuServiceProps) => (
  <ProviderEntities entities={entities}>
    <ProviderCallPopUpGlobal value={callPopUpGlobalStore}>
      <RouterProvider router={router} />
    </ProviderCallPopUpGlobal>
  </ProviderEntities>
)
